"use client";

import { useNonce } from "../lib/security/use-nonce.js";

interface SpeculationRulesProps {
  readonly prerenderUrls?: string[];
}

const DEFAULT_PRERENDER_URLS: string[] = [];

export const SpeculationRules = ({
  prerenderUrls = DEFAULT_PRERENDER_URLS,
}: SpeculationRulesProps) => {
  const nonce = useNonce();

  return (
    <script type="speculationrules" nonce={nonce} suppressHydrationWarning>
      {JSON.stringify({
        prerender: [
          {
            urls: prerenderUrls,
          },
          {
            eagerness: "moderate",
            where: {
              href_matches: "/*",
            },
          },
        ],
      })}
    </script>
  );
};
